/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompetenceDetail { 
    readonly id: string;
    /**
     * Zadejte název kompetence.
     */
    title: string;
    /**
     * Zadejte odborný název kompetence.
     */
    officialName?: string;
    readonly categoryName: string;
    readonly touchCount: number;
    readonly isWatched: boolean;
    readonly categoryId: number;
    readonly categoryColor: string;
    /**
     * Zadejte popis kompetence na první úrovni. (3-4 let)
     */
    firstLevelDescription?: string;
    /**
     * Zadejte popis kompetence na druhé úrovni. (4-5 let)
     */
    secondLevelDescription?: string;
    /**
     * Zadejte popis kompetence na třetí úrovni. (5-6 let)
     */
    thirdLevelDescription?: string;
}